export const LOGLEVEL = {
  DISABLE: 'DISABLE',
  ERROR: 'ERROR',
  WARN: 'WARN',
  INFO: 'INFO',
  DEBUG: 'DEBUG',
  DEBUG1: 'DEBUG1',
  DEBUG2: 'DEBUG2',
  DEBUG3: 'DEBUG3',
  TRACE: 'TRACE',
  LOG: 'LOG',
} as const;
